module.exports = __webpack_public_path__ + "static/media/CaretDoubleDown.2241774a.svg";